import { useState } from 'react';
import { useSelector } from 'react-redux';
import ReportablesList from './ReportablesList';
import TableTitle from '../../Shared/Table/widgets/TableTitle';
import TablePageContainer from '../../Shared/Table/widgets/TablePageContainer';

const Reportables = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(' ');

  return (
    <>
      <TablePageContainer>
        <ReportablesList
          setFilterStyle={setFilterStyle}
          setTotalCount={setTotalCount}
          tableTitle={<TableTitle
            titleText={titles.reportables}
            count={totalCount}
            countFiltered={filterStyle}
          />}
        />
      </TablePageContainer>
    </>
  );
};

export default Reportables;

